<template>
    <div id="app">
        <div id="header">
            <router-link id="logo" to="/">
                <img  width="138" height="42" src="https://firebasestorage.googleapis.com/v0/b/wasteaway-fyp.appspot.com/o/logo.png?alt=media&token=86a12962-3697-4694-8e17-72f97ad8df41" />
            </router-link>
                <div id="nav">
                    <router-link to="/">Home</router-link> |
                    <router-link to="/features">Features</router-link> |
                    <router-link to="/research">The Research</router-link> |
                    <router-link to="/download">Download</router-link>
                </div>

                <Slide class="mobileNav" right>
                    <router-link to="/">Home</router-link>
                    <router-link to="/features">Features</router-link>
                    <router-link to="/research">The Research</router-link>
                    <router-link to="/download">Download</router-link>
                </Slide>
</div>
        <router-view />
        <Footer />
    </div>
</template>

<style lang="scss">
    @media only screen and (min-device-width : 320px) {
        body {
            margin: 0;
            position: relative;
            min-height: 100vh;
        }

        #app {
            font-family: Avenir, Helvetica, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            text-align: center;
            color: #2c3e50;
            padding-bottom: 100px;
        }

        #header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 3em;
            padding-top: 0.7em;
            padding-left: 1.5em;
        }

        #logo {
            width: auto;
            height: 100%;
        }

        #nav {
            display: none;
        }
        
        .bm-burger-button {
            width: 1em;
            height: 1em;
            position: relative;
            top: 0;
            left: 0;
        }

        .bm-item-list a {
            color: white;
        }

        .cross-style {
            top: 30px;
        }

        a {
            font-weight: bold;
            color: #2c3e50;
            text-transform: uppercase;
        }

        a.router-link-exact-active {
            color: #42b983;
        }

        
    }

    @media only screen and (min-device-width : 768px) {
        #header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        #nav {
            display: block;
            padding: 30px;
            
        }

        #nav * {
            text-decoration: none;
        }

            #nav a:last-child {
                background: #42b983;
                color: white;
                padding: 5px 10px;
                border-radius: 10px;
            }

        .mobileNav {
            display: none;
        }
    }
</style>

<script>
    import Footer from "@/components/Footer.vue";
    import { Slide } from 'vue-burger-menu'
    export default {
        name: "App",
        components: {
            Footer,
            Slide
        }
    };
</script>
